import { useAppDispatch, useAppSelector } from "@/app/hooks";
import { selectThreeDSAuthData } from "@/pages/CheckoutPayment/checkoutPaymentSlice";
import { useEffect, useMemo, useRef } from "react";
import { showNotification } from "../basic/NotificationBar/notificationBarSlice";
import { SimpleDialogComponent } from "../basic/SimpleDialog/SimpleDialog";

const PAYMENT_SUCCESS = "success";
const PAYMENT_FAILD = "failed";

type Props = {
  nextPage: Function;
};

export const ThreeDAuthDialog = ({ nextPage }: Props) => {
  const dialogRef = useRef(null);
  const threeDSAuthData = useAppSelector(selectThreeDSAuthData);
  const dispatch = useAppDispatch();

  useEffect(() => {
    const handlePaymentMessage = (e: MessageEvent) => {
      const data = e?.data;
      if (data.type === "payment") {
        const payload = data.payload;
        console.log(payload);

        (dialogRef?.current as any)?.closeDialog();
        if (payload?.status === PAYMENT_SUCCESS) {
          nextPage();
        } else if (payload?.status === PAYMENT_FAILD) {
          dispatch(showNotification("Payment failed, please try it again."));
        }
      }
    };
    window.addEventListener("message", handlePaymentMessage);
    return () => {
      window.removeEventListener("message", handlePaymentMessage);
    };
  }, []);

  useEffect(() => {
    if (threeDSAuthData && threeDSAuthData.status === "3DAUTH") {
      (dialogRef.current as any).openDialog(true);
    }
  }, [threeDSAuthData]);

  const query = useMemo(() => {
    if (threeDSAuthData) {
      return Object.keys(threeDSAuthData)
        .map((key) => {
          return (
            encodeURIComponent(key) +
            "=" +
            encodeURIComponent(threeDSAuthData[key])
          );
        })
        .join("&");
    }
  }, [threeDSAuthData]);
  return (
    <SimpleDialogComponent ref={dialogRef}>
      {threeDSAuthData && (
        <>
          <h2 className="text-2xl mt-3 mb-3">
            Verification is required by your bank.
          </h2>
          <iframe
            className="w-full"
            src={`/checkout/3ds-auth?${query}`}
            title="3ds"
            style={{ height: "450px" }}
          ></iframe>
        </>
      )}
    </SimpleDialogComponent>
  );
};
